import { api } from 'shared/api';

import { FetchWorkCalendarResponse } from '../types';

export interface FetchWorkCalendarPayload {
    from: string;
    to: string;
}

export async function fetchWorkCalendar(
    { from, to }: FetchWorkCalendarPayload,
    signal?: AbortSignal
) {
    const config = {
        params: { from, to },
        signal
    };

    return api.get<FetchWorkCalendarResponse>(
        'candidatePortal/Availability/Calendar',
        undefined,
        config
    );
}
